import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { css, StyleSheet } from 'aphrodite/no-important';
import {
  Drawer,
  TextInputWithLabel
} from 'quantux-ui';
import { getUsersForDms, selectDmUser, sendDm, postMessageToDM } from '../../actions';
import { gray, salmon, blue } from '../../theme';
import { debugLogToConsole, getHighlightedText, padZero } from '../../utils';

const DMDrawer = (props) => {
  const [showSendDmDrawer, setShowSendDmDrawer] = useState(false);
  const [newMessage, setNewMessage] = useState('');
  const [dms, setDms] = useState([]);
  const [userSearch, setUserSearch] = useState('');

  // Effects
  useEffect(() => {
    props.getUsersForDms();
  }, []);

  useEffect(() => {
    if (dms.length !== props.activeDmMessages.length) {
      setDms(props.activeDmMessages);
    }
  }, [props.activeDmMessages]);

  useEffect(() => {
    if (props.isVisible !== showSendDmDrawer) {
      setShowSendDmDrawer(props.isVisible);
    }
  }, [props.isVisible]);

  const styles = StyleSheet.create({
    drawerContainer: {
      background: gray[700],
      color: gray[300],
      height: '100%',
      position: 'relative',
      display: 'flex',
      flexFlow: 'column'
    },
    drawerHeader: {
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 8px',
      fontWeight: 'bold',
      borderBottom: '1px solid black',
      flexShrink: '0'
    },
    drawerHeaderCloseIcon: {
      color: gray[300],
      ':hover': {
        color: salmon[500]
      }
    },
    drawerContentArea: {
      overflowY: 'auto',
      color: gray[300],
      flexGrow: '1'
    },
    drawerFooter: {
      alignItems: 'center',
      justifyContent: 'flex-end',
      background: gray[700],
      height: '60px',
      width: '100%',
      borderTop: `1px solid ${gray[500]}`,
      flexShrink: '0'
    },
    dmUserCard: {
      borderRadius: '4px',
      height: '40px',
      background: gray[600],
      color: gray[200],
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: 'bold',
      ':not(.active):hover': {
        background: gray[700]
      }
    },
    dmUserCardActive: {
      background: blue[900],
      color: blue[500]
    },
    chatSendBtn: {
      fontSize: '22px',
      ':hover': {
        color: blue[400]
      }
    }
  });

  const handleOnEditNewMessage = (e) => {
    const { value } = e.target;
    setNewMessage(value);
  };

  const handleOnEditUserSearch = (e) => {
    const { value } = e.target;
    setUserSearch(value);
  };

  const handleOnSendDm = () => {
    if (props.activeDmMessages.length === 0) {
      props.sendDm({
        recipientId: props.activeDmUser,
        message: {
          msg: newMessage,
          isImage: false,
          isDocument: false,
        }
      });
    } else {
      const { _id } = props.activeDm;
      props.postMessageToDM({
        dmId: _id,
        recipientId: props.activeDmUser,
        msg: newMessage,
        message: {
          msg: newMessage,
          isImage: false,
          isDocument: false,
        }
      });
    }

    setNewMessage('');
  };

  return (
    <Drawer
      placement="right"
      className='dm-drawer'
      visible={props.isVisible}
      toggleDrawer={props.onClose}
      zIndex="2052"
      width={window.innerWidth <= 700 ? window.innerWidth : 700}
    >
      <div className={css(styles.drawerContainer)}>
        {/* Header */}
        <div className={css(styles.drawerHeader)}>
          <div className='fx fx__hv-center'>
            <i className='mr-2 fa fa-lg fa-user' />
            <div className='noselect'>Send DM</div>
          </div>
          <i
            className={`fa fa-lg fa-times-circle ${css(styles.drawerHeaderCloseIcon)}`}
            onClick={() => {
              props.onClose();
            }}
          />
        </div>
        {/* Middle area */}
        <div
          className={css(styles.drawerContentArea)}
          style={{
            display: 'flex',
            flexFlow: 'row'
          }}
        >
          {/* Side Panel */}
          <div
            className='p-2'
            style={{
              width: '250px',
              height: '100%',
              background: gray[900]
            }}
          >
            <div>
              <TextInputWithLabel
                value={userSearch}
                className='mb-2'
                titleText="Search Users"
                titleFontSize={12}
                isCompactLayout={true}
                titleColor={gray[200]}
                textColor="white"
                selectionColor="white"
                selectionBackground="#0080FF"
                spellcheck={false}
                width={234}
                showClearFieldIcon
                onChange={handleOnEditUserSearch}
              />
            </div>
            <div>
              {props.dmUsers.filter(user => new RegExp(`${userSearch}`, 'i').test(user.displayName)).map((user) => {
                return (
                  <div
                    key={user._id}
                    className={`noselect mt-1 pl-2 pr-2 ${props.activeDmUser === user._id ? 'active' : ''} ${css(styles.dmUserCard, props.activeDmUser === user._id && styles.dmUserCardActive)}`}
                    onClick={() => {
                      props.selectDmUser(user._id, user.userName);
                    }}
                  >
                    <div style={{ position: 'relative' }}>
                      <img
                        src={user.avatarImageUrl}
                        className='mr-2'
                        style={{
                          borderRadius: '25%',
                          height: '28px',
                          maxHeight: '28px',
                          width: 'auto'
                        }}
                      />
                      {Array.isArray(props.alertSenderUserNames) && props.alertSenderUserNames.length > 0 && props.alertSenderUserNames.indexOf(user.userName) > -1 &&
                        <i
                          className='ml-1 fa fa-exclamation-circle'
                          style={{
                            position: 'relative',
                            top: '-14px',
                            left: '-18px',
                            fontSize: '16px',
                            color: salmon[500],
                            borderRadius: '30%',
                            cursor: 'pointer',
                            minWidth: '12px',
                            textAlign: 'center'
                          }}
                        />
                      }
                    </div>
                    {getHighlightedText(`${user.displayName}${user.credentials ? ', ' + user.credentials : ''}`, userSearch)}
                  </div>
                );
              })}
              {userSearch.length > 0 && props.dmUsers.filter(user => new RegExp(`${userSearch}`, 'i').test(user.displayName)).length === 0 &&
                <div>
                  No user matched search criteria
                </div>
              }
            </div>
          </div>
          {/* Chat messages area */}
          <div
            className='p-2'
            style={{
              flexGrow: 1,
              display: 'flex',
              flexFlow: 'column',
              flexDirection: 'column-reverse',
              overflowY: 'auto'
            }}
          >
            {dms.length === 0 &&
              <div className='font-20'>
                Select user to send DM
              </div>
            }
            {dms.map((dm, idx) => {
              const currentUserName = props.usr.userName;
              const {
                dateTime,
                isDocument,
                isImage,
                msg = '',
                senderDisplayName,
                senderUserName,
                status
              } = dm;

              const msgDate = new Date(Date.parse(dateTime));
              const msgTimeStamp = `${padZero(msgDate.getHours())}:${padZero(msgDate.getMinutes())}`
              return (
                <div
                  key={dm._id || dm.id}
                  style={{
                    display: 'flex',
                    flexFlow: 'column',
                    alignItems: currentUserName !== senderUserName ? 'flex-start' : 'flex-end'
                  }}
                >
                  <div className='font-14'>
                    {msgTimeStamp}
                  </div>
                  <div
                    style={{
                      borderRadius: '10px',
                      width: '85%',
                      padding: '8px',
                      background: currentUserName !== senderUserName ? gray[800] : blue[800],
                      color: 'white',
                    }}
                  >
                    {msg}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {/* Footer */}
        <div
          className={`fx pl-3 pr-3 ${css(styles.drawerFooter)}`}
        >
          <TextInputWithLabel
            value={newMessage}
            className='mb-2'
            titleText="Type message ..."
            titleFontSize={12}
            isCompactLayout={true}
            titleColor={gray[200]}
            textColor="white"
            selectionColor="white"
            selectionBackground="#0080FF"
            spellcheck={false}
            width={640}
            onChange={handleOnEditNewMessage}
          />
          <i
            className={`ml-2 fa fa-toggle-right ${css(styles.chatSendBtn)}`}
            onClick={handleOnSendDm}
          />
        </div>
      </div>
    </Drawer>
  );
};

function mapStateToProps({ user }) {
  return { ...user };
}
export default connect(
  mapStateToProps, {
    getUsersForDms,
    selectDmUser,
    sendDm,
    postMessageToDM
  })(DMDrawer);
